import React from 'react'
import { Link } from 'react-router-dom'
import { routesDef } from '../../config/routes'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { OrderStatusEnum } from '@ztechapps/common.contract'
import { useContext } from './Context'

export const PayNowButton = ({ checkoutPage }: { checkoutPage?: string }) => {
  const { document } = useContext()

  checkoutPage = checkoutPage ?? routesDef.CartPage.altPath({ orderId: document?._id })

  return (
    <ShowIf condition={document?.status === OrderStatusEnum.ReadyForPayment}>
      <Link to={checkoutPage} className="btn   btn-primary">
        <Icon name="stripe" /> Pay Now!
      </Link>
    </ShowIf>
  )
}
